import { testimonials } from '@/mocks/homeData';

export default function TrustSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Section header */}
        <div className="mb-10 md:mb-14">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs tracking-[0.3em] uppercase text-foreground-500 font-medium">
              USER TRUST
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 leading-tight">
            Trusted by Smart Shoppers
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2 md:mt-3 max-w-md">
            Thousands of users rely on the{' '}
            <strong className="text-foreground-800">itaobuyspreadsheet</strong> system to make better shopping decisions every day.
          </p>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t, idx) => (
            <div
              key={t.name}
              className={`rounded-xl bg-background-50 p-5 md:p-6 flex flex-col ${
                idx === testimonials.length - 1 ? 'opacity-60' : ''
              }`}
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className={`text-xs ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                  </span>
                ))}
              </div>

              <h4 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 font-heading">
                {t.name.split(' ')[0]}&apos;s Review
              </h4>

              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1 mb-4">
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-9 h-9 rounded-full object-cover flex-shrink-0"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}